import { render, staticRenderFns } from "./CallContact.vue?vue&type=template&id=5242fd6a"
import script from "./CallContact.vue?vue&type=script&lang=js"
export * from "./CallContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports